export default __webpack_public_path__ + "static/media/SAS Alert Tone 1.043a3b8f.wav";